export default __webpack_public_path__ + "static/media/menu_my_gifts_okara.698e020e.svg";